const BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:8080"
    : "https://dealswapify.onrender.com";

export default BASE_URL;